import React from "react";
import "./Mission.css";

const data = [
  {
    title: "Our Mission",
    text: "EES is committed to promoting environmental literacy, fostering sustainable practices, and empowering communities to become agents of positive change. Through innovative education initiatives, collaborative partnerships, and advocacy efforts, we strive to create a more equitable and sustainable world for present and future generations.",
    img: "images/childrens-day.jpg",
  },
  {
    title: "Our Vision",
    text: "To create a sustainable and equitable world where empowered communities, quality education, and environmental responsibility come together to build a better future for generations to come.",
    img: "images/republic-day.jpg",
  },
  {
    title: "Our Values",
    text: "We believe in the power of education to inspire awareness, critical thinking, and lifelong growth, while promoting environmental stewardship through sustainable practices that protect nature and biodiversity. Our approach is rooted in community engagement, fostering collaboration and inclusive participation to create meaningful impact. We embrace innovation by leveraging creativity and technology to address environmental challenges, and remain committed to equity and justice by ensuring fair opportunities and supporting communities most affected. Through our programs, we deliver environmental education, community outreach, policy advocacy, research-driven solutions, and capacity building to empower individuals as responsible and effective change-makers.",
    img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
  },
];

const Mission = () => {
  return (
    <section className="mission-section">
      
      {/* Heading */}
      <div className="mission-header">
        <span>OUR DIRECTION</span>
        <h2>Our Purpose, Clearly Defined</h2>
        <p>
          The work we do is guided by a clear mission and a bold vision for the future.
        </p>
      </div>

      {/* Cards */}
      <div className="mission-cards">
        {data.map((item, index) => (
          <div className="mission-card" key={index}>
            
            <div className="mission-left">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>

            <div className="mission-right">
              <img src={item.img} alt="" />
            </div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default Mission;